import PageHead from '@/components/PageHead';
import PageLayout from '@/components/layout/page-layout';
import Container from '@/components/Container';
import HeadingOne from '@/components/Heading/HeadingOne';

import NextImage from 'next/image';
import NextLink from 'next/link';
import { SocialActionCard } from '@/components/SocialActionCard';
import { ExtendProps } from 'app';
import { FiExternalLink } from 'react-icons/fi';
import SocialActionLink from '@/components/SocialActionLink';

export default function Page() {
	return (
		<>
			<PageHead
				page={{
					title:
						'Instituto Deixe Vivo | Rede de acolhimento: pacientes e cuidadores',
					keywords:
						'OSC, Instituto, Deixe Vivo, Doação de órgãos e tecidos, transplantes, renal, tecidos, história, trajetória',
					colorScheme: 'light dark',
					description: 'Instituto Deixe Vivo',
					robots: 'follow, index',
				}}
				og={{
					description:
						'Instituto Deixe Vivo | Rede de acolhimento: pacientes e cuidadores',
					site_name:
						'Instituto Deixe Vivo | Rede de acolhimento: pacientes e cuidadores',
					title:
						'Instituto Deixe Vivo | Rede de acolhimento: pacientes e cuidadores',
					type: 'website',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						fbAdmins: 'instituto.deixevivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
						type: 'image/jpg',
						width: '1200',
						height: '1200',
					},
				}}
				twitter={{
					card: 'summary',
					description:
						'Instituto Deixe Vivo | Rede de acolhimento: pacientes e cuidadores',
					site: 'Instituto Deixe Vivo | Rede de acolhimento: pacientes e cuidadores',
					title:
						'Instituto Deixe Vivo | Rede de acolhimento: pacientes e cuidadores',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
					},
				}}
			/>
			<PageLayout>
				<Container className="py-8">
					<div className="relative">
						<HeadingOne horizontalRow>
							Rede de acolhimento: pacientes e cuidadores
						</HeadingOne>
						{/* <NextImage
							className="float-right lg:-mt-6 lg:ml-16"
							width={192}
							height={192}
							src="https://res.cloudinary.com/oliveiradev/image/upload/v1688396073/InstitutoDeixeVivo/logos/logo-rede-de-acolhimento.png"
							alt="Rede de acolhimento: pacientes e cuidadores"
						/> */}
					</div>
					<section className="my-4">
						<p tabIndex={0}>
							Fazer inúmeros exames e consultas médicas com frequência, passar
							por tratamentos substitutivos, ter restrições alimentares e/ou
							hídricas, entrar em uma lista de espera gigantesca – que hoje
							passa de 60mil pessoas no Brasil – para receber um transplante,
							passar pela cirurgia e pelo pós-operatório do transplante, tomar
							imunossupressores, entre outros vários detalhes da vida de um(a)
							paciente com doença crônica, pode afetar – e muito – a saúde
							emocional desse(a) mesmo(a) paciente. Pensando nisso e nas
							possíveis restrições alimentares e/ou hídricas de pacientes
							renais... O{' '}
							<span className="text-primary-dark">
								<strong>Instituto Deixe Vivo</strong>
							</span>{' '}
							criou a <strong>Rede de Acolhimento</strong>! Hoje, dividida em
							duas frentes de atuação:
						</p>

						<ul
							role="list"
							className="mt-8 w-full flex gap-16 items-center flex-col xl:flex-row py-8"
						>
							<li tabIndex={0}>
								<div
									className={`relative max-w-[100%] flex flex-col items-start shadow-md rounded-xl`}
								>
									<div className="relative w-full text-center [border-top-left-radius:8px] [border-top-right-radius:8px] py-1 text-black border-b-2 border-b-primary-dark">
										<strong className="text-sm text-primary-dark">
											Acolhimento
										</strong>
									</div>
									<div className="px-4 pt-2 pb-8 rounded-b-2xl rounded-br-2xl text-center flex-1 text-black">
										<div className="py-4">
											<NextImage
												className="mx-auto inline-block h-auto"
												width={160}
												height={0}
												src="/assets/images/illustrations/logo-suporte-emocional-letras-pretas-1.png"
												alt="Rede de acolhimento: pacientes e cuidadores"
											/>
										</div>
										<p className="text-left">
											Tem como objetivo apoiar e acolher pacientes renais em
											todos os possíveis estágios e tratamentos da doença,
											pacientes em lista de espera para receber um transplante e
											pacientes transplantados. Realizado por meio de psicólogas
											parceiras de nossa Instituição – profissionais devidamente
											credenciadas no Conselho Regional de Psicologia (CRP).
										</p>
									</div>

									<div className="absolute -bottom-6 left-1/2 w-[12rem] -translate-x-1/2 mx-auto bg-primary-dark text-white rounded uppercase text-sm font-bold">
										<NextLink
											className="flex justify-center w-full h-full cursor-pointer p-3 "
											target="_blank"
											href="https://forms.gle/iphezpSysY7XEzUg7"
										>
											<span>Cadastre-se!</span>
											<FiExternalLink className="ml-1" />
										</NextLink>
									</div>
								</div>
							</li>
							<li tabIndex={0}>
								<div
									className={`relative max-w-[100%] flex flex-col items-start shadow-md rounded-xl`}
								>
									<div className="relative w-full text-center [border-top-left-radius:8px] [border-top-right-radius:8px] py-1 text-black border-b-2 border-b-primary-dark">
										<strong className="text-sm text-primary-dark">
											Acolhimento
										</strong>
									</div>
									<div className="px-4 pt-2 pb-8 rounded-b-2xl rounded-br-2xl text-center flex-1 text-black">
										<div className="py-4">
											<NextImage
												className="mx-auto inline-block h-auto"
												width={160}
												height={0}
												src="/assets/images/illustrations/logo-orientacao-nutricional-1.png"
												alt="Rede de acolhimento: pacientes e cuidadores"
											/>
										</div>
										<p className="text-left">
											Tem como objetivo orientar a alimentação de pacientes
											renais, visto que, em muitos momentos da doença renal
											crônica, esses pacientes passam por inúmeras restrições
											alimentares e possíveis restrições hídricas. Realizado por
											meio de nutricionistas parceiras de nossa Instituição –
											profissionais devidamente credenciadas no Conselho
											Regional de Nutricionistas (CRN).
										</p>
									</div>

									<div className="absolute -bottom-6 left-1/2 w-[12rem] -translate-x-1/2 mx-auto bg-primary-dark text-white rounded uppercase text-sm font-bold">
										<NextLink
											className="flex justify-center w-full h-full cursor-pointer p-3"
											target="_blank"
											href="https://forms.gle/aNU2HaMbtSBnSQH59"
										>
											<span>Cadastre-se!</span>
											<FiExternalLink className="ml-1" />
										</NextLink>
									</div>
								</div>
							</li>

							{/* <li tabIndex={0}>
								<SocialActionCard
									context="Evento Online"
									title="Programa “Protagonista da minha história”"
									description="Criamos a jornada
									do paciente transplantado considerado principalmente o
									primeiro ano de transplante com todas as mudanças e
									diversidades desse momento por meio de cartilhas, encontros
									coletivos e workshops"
									Link={
										<SocialActionLink>
											<span className="flex justify-center w-full h-full cursor-pointer p-3 ">
												<span>Em breve!</span>
											</span>
										</SocialActionLink>
									}
								/>
							</li> */}

							{/* <li tabIndex={0}>
								<SocialActionCard
									context="Grupo de Apoio"
									title="Comunidade"
									description="Grupo de transplantados e grupo de pacientes em
									hemodiálise, grupo de cuidadores no WhatsApp, para troca e
									acolhimento diário."
									Link={
										<SocialActionLink>
											<span className="flex justify-center w-full h-full cursor-pointer p-3 ">
												<span>Em breve!</span>
											</span>
										</SocialActionLink>
									}
								/>
							</li> */}

							{/* <li tabIndex={0}>
								<SocialActionCard
									context="Evento Online"
									title="Atendimento"
									description="Atendimento nutricional e/ou psicológico por meio de plantão
									que acontecerá uma vez na semana."
								/>
							</li> */}

							{/* <li tabIndex={0}>
								<SocialActionCard
									context="Grupo de Apoio"
									title='Cuidadores "Cuidar de quem cuida"'
									description="Com a nossa psicóloga parceira há encontros entre familiares
									cuidadores, tendo como proposta acolher e olhar com atenção aqueles que se dedicam
									ao cuidado de outra pessoa."
									Link={
										<SocialActionLink>
											<span className="flex justify-center w-full h-full cursor-pointer p-3 ">
												<span>Em breve!</span>
											</span>
										</SocialActionLink>
									}
								/>
							</li> */}
						</ul>
					</section>

					<section className="py-10">
						<p>
							Ainda temos muito trabalho pela frente, mas sendo uma{' '}
							<strong>Instituição do Terceiro Setor</strong>, precisamos do seu
							apoio para dar continuidade aos projetos já existentes e para
							executar os nossos novos projetos:
						</p>
						<ul className="list-disc px-8">
							<li>
								Programa <strong>“Protagonista da minha história”</strong> –
								criação de materiais para cartilhas, encontros/workshops
								presenciais ou online para orientar pacientes em diferentes
								cenários (desde a entrada na hemodiálise, até a longa jornada do
								primeiro ano de transplante) e demais interessados e/ou
								envolvidos.
							</li>

							<li>
								<strong>Comunidades de Apoio</strong> – para acolher diferentes
								grupos de pacientes e cuidadores (quem ajuda nos cuidados do
								paciente).
							</li>
						</ul>
						<div className="mt-4">
							<NextLink
								href="/apoio"
								target="_blank"
								className="bg-primary-dark py-3 px-4 text-white rounded uppercase relative font-bold"
							>
								quero apoiar os projetos!
							</NextLink>
						</div>
					</section>
				</Container>
			</PageLayout>
		</>
	);
}
